import { makeRequest, formatDateParam } from "../lib/makeRequest";

export const daily_summary_overall_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.covered_date) };
  return makeRequest("/daily-transactions/overall", params);
};

export const daily_summary_cluster_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.covered_date) };
  return makeRequest(`/daily-transactions/cluster/${data.clusterId}`, params);
};

export const daily_summary_area_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : { coveredDate: formatDateParam(data.covered_date) };

  return makeRequest(`/daily-transactions/area/${data.area_code}`, params);
};

export const daily_summary_branch_v4 = (data) => {
  const urlParams = new URLSearchParams();

  if (data.isRange) {
    urlParams.append("from", formatDateParam(data.dates.from));
    urlParams.append("to", formatDateParam(data.dates.to));
  } else {
    urlParams.append("coveredDate", formatDateParam(data.covered_date));
  }

  return makeRequest(
    `/daily-transactions/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
